import { AxiosInstance } from "axios"
import { ServiceCenterAdminsItem } from "./adminsTypes"

export enum ServiceCenterAdminsQuery {
    ADMINS_FOR_SERVICE_CENTER = "admins-for-service-center",
}

export type ServiceCenterAdminsParams = Readonly<{
    serviceCenterId: number
}>

export type ServiceCenterAdminsResponse = Readonly<{
    administrators: ServiceCenterAdminsItem[]
}>

export async function fetchServiceCenterAdmins(
    { serviceCenterId }: ServiceCenterAdminsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceCenterAdminsResponse> {
    const url = `/serviceCenters/${serviceCenterId}/administrators`
    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
